"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.resetUserFeed = exports.loadUserFeedError = exports.loadUserFeedSuccess = exports.loadUserFeed = void 0;

var loadUserFeed = function loadUserFeed(payload) {
  var _ref = payload || {},
      userId = _ref.userId,
      clientId = _ref.clientId,
      next = _ref.next,
      apiVersion = _ref.apiVersion;

  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_FEED',
    payload: {
      userId: userId,
      clientId: clientId,
      next: next,
      apiVersion: apiVersion
    }
  };
};

exports.loadUserFeed = loadUserFeed;

var loadUserFeedSuccess = function loadUserFeedSuccess(userFeed) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_FEED_SUCCESS',
    payload: {
      userFeed: userFeed
    }
  };
};

exports.loadUserFeedSuccess = loadUserFeedSuccess;

var loadUserFeedError = function loadUserFeedError(error) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_FEED_ERRROR',
    payload: {
      error: error
    }
  };
};

exports.loadUserFeedError = loadUserFeedError;

var resetUserFeed = function resetUserFeed() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_USER_FEED'
  };
};

exports.resetUserFeed = resetUserFeed;
var _default = {
  loadUserFeed: loadUserFeed,
  loadUserFeedSuccess: loadUserFeedSuccess,
  loadUserFeedError: loadUserFeedError,
  resetUserFeed: resetUserFeed
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map